const system = [
  '-apple-system',
  'BlinkMacSystemFont',
  '"Segoe UI"',
  'Roboto',
  '"Helvetica Neue"',
  'Arial',
  '"Noto Sans"',
  'sans-serif',
  '"Apple Color Emoji"',
  '"Segoe UI Emoji"',
  '"Segoe UI Symbol"',
  '"Noto Color Emoji"',
];

const heading = ['"Open Sans"', ...system];

const body = ['"Source Sans Pro"', ...system];

// const monospace = [
//   'SFMono-Regular',
//   'Menlo',
//   'Monaco',
//   'Consolas',
//   '"Liberation Mono"',
//   '"Courier New"',
//   'monospace',
// ];

export default {
  heading: heading.join(','),
  body: body.join(','),
};
